import classNames from 'classnames';

const TempoHeaderUnderline = ({ className = '' }) => {
  return (
    <svg
      className={classNames('', className)}
      fill="none"
      height="12"
      preserveAspectRatio="none"
      viewBox="0 0 153 12"
      width="400"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Tempo Header Underline</title>
      <path
        d="M152.978 7.98683C151.901 15.0667 112.66 10.9713 90.1285 9.2717C67.5968 7.57207 17.7039 11.309 7.28078 10.3343C-2.24359 9.44362 -1.20361 4.49142 3.47229 2.54581C15.1498 -2.31312 74.0216 1.27702 100.126 1.27702C110.123 1.27702 154.128 0.424067 152.978 7.98683Z"
        className="fill-tempo-navy-100"
      ></path>
    </svg>
  );
};

TempoHeaderUnderline.propTypes = {
  className: PropTypes.string,
};

export default TempoHeaderUnderline;
